import React, { useEffect, useState } from "react";

import { formatDateWithBitwiseOR } from "utils/utils";
import { BaselineStrings } from "constants/constantStrings";

import "./BaselineReadOnlyView.scss";

export default function BaselineReadOnlyView({ baselineData }) {
  const [baselineTags, setBaselineTags] = useState([]);

  useEffect(() => {
    if (baselineData) {
      const tags = baselineData.Values?.map(item => {
        const baselineTag = baselineData.NormalizationTags[item.tagId];
        const { TagName, Units } = baselineTag.tag;
        return { label: `${baselineTag.label} - `, value: `${TagName} (${item.value} ${Units})` };
      });
      if (tags) tags.push({}, {});
      setBaselineTags(tags);
    }
  }, [baselineData.NormalizationTags]);

  const getBaselineTime = () => {
    let result = "";
    const { Timezone, Date } = baselineData;
    if (Timezone && Date) {
      result = `${Timezone} | ${formatDateWithBitwiseOR(Date)}`;
    }
    return result;
  };

  return (
    <>
      {baselineData && (
        <div className="baseline-table_popup_container">
          <div className="dialog-row m-0">
            <label className="col-name text-underline">{BaselineStrings.baselineId}</label>
            <label className="col-value">{baselineData.baselineID}</label>
          </div>
          {/* <div className="dialog-row">
                        <label className='col-name text-underline'>Baseline Title:</label>
                        <label className="col-value">{baselineData.Title}</label>
                    </div> */}
          <div className="dialog-row">
            <label className="col-name text-underline">{BaselineStrings.baselineTimestamp}</label>
            <label className="col-value">{getBaselineTime()}</label>
          </div>
          <div className="dialog-row">
            <div className="col-name text-underline">{BaselineStrings.baselineValue}</div>
          </div>
          <div className="baseline-tags-container">
            {baselineTags &&
              baselineTags.map(item => (
                <div className="baseline-tags-item">
                  <label className="col-value">{item.label}</label>
                  <label className="col-name">&nbsp;{item.value}</label>
                </div>
              ))}
          </div>
        </div>
      )}
    </>
  );
}
